const project1=""
const project2=""
const project3=""
const project4=""
const project5=""
const project6=""
export const projects = [
    {
      name: "Stock Tracker (django)",
      description: ["It's Stock Tracking APP.",
      'Stock data updates in REAL-TIME',
      "For the real-time update done through 'django-channels'.",
      "Data comes from the 'yahoo-finance' website by 'django-celery.'"
      ],
      image: project1,
      source_code:"https://github.com/asad2200/Stock-Tracker",
    },
    {
      name: "Job Portal (django)",
      description: ["It's App where EMPLOYER POST JOBS and JOBSEEKER APPLY.", 
      'Employer and jobseeker can chat within the app.',
      'Also, the Employer can schedule a ZOOM meeting for interviews within the app.',
      "ZOOM meeting feature adds through ZOOM API."
      ],
      image: project2,
      source_code:"https://github.com/asad2200/JobPortal",
    },
    {
      name: "authsimple (django-package)",
      description: [
        "authsimple is a package that includes an AUTHENTICATION SYSTEM in DJANGO PROJECT.",
        "It can be installed using 'pip install Django-authsimple'.",
        "This package also contain EMAIL VALIDATION & FORGOT PASSWORD on EMAIL as well"
      ],
      image: project4,
      source_code:"https://github.com/asad2200/authsimple",
      live:"https://pypi.org/project/django-authsimple/",
    },
    {
      name: "Github User Detail",
      description: [
        "This is created by REACTJS., FIREBASE",
        'Basically we can search github profile by username and see detail.',
        "Github profile info fetch by GITHUB API."
      ],
      image: project6,
      source_code:"https://github.com/asad2200/github-user-search",
      live:"https://github-api-9b877.web.app/signin",
    },
    {
      name: "Url Shortener (django)",
      description: ['This project make a url short.'],
      image: project3,
      source_code:"https://github.com/asad2200/UrlShortener",
      live:"https://url-short-asad.herokuapp.com/",
    },  
    {
      name: "Automart (frontend + backend)",
      description: ["It's a Website for a CAR ACCESSORIES SHOP.",
      "Frontend created using REACTJS. ",
      "Backend is created using 'django-rest-framework'."
      ],
      image: project5,
      source_code:"https://github.com/asad2200/automart-frontend",
      live:"https://auto-mart.netlify.app/",
    },   
    {
      name: "Bookkeeping (DesktopApp JAVA)",
      description: ["It's INVENTORY MANAGMENT SYSTEM in JAVA(SWING).",
      'This is first big project i created. :)',
      ],
      image: project5,
      source_code:"https://github.com/asad2200/Book-Keeping",
    },   
];

